import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/components';
import ResourcesDashboard from '@/pages/ResourcesDashboard';

export const Route = createFileRoute('/interimaires')({
  component: () => (
    <ProtectedRoute>
      <ResourcesDashboard />
    </ProtectedRoute>
  ),
});
